// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._VEQSmMHqM84jA {
  width: 100%;
  list-style-type: none;
}
._VEQSmMHqM84jA.DuzkrSUJiOPXP4 {
  opacity: 0.4;
}
._VEQSmMHqM84jA.Sv2W0Enm0ueRbF {
  display: none;
}
.VCrcTH6nCHY0y7 {
  margin: var(--ds-space-050, 4px);
}
.l_NGnetFCZe3nk {
  height: 100%;
  margin: var(--ds-space-0, 0);
}
.TWQslu3N2ieXcM {
  width: 100%;
  min-height: 40px;
  border-radius: var(--ds-border-radius-200, 8px);
  background-color: var(--ds-background-accent-gray-subtlest, #f1f2f4);
}
.TWQslu3N2ieXcM[role='gridcell'] {
  margin: var(--ds-space-050, 4px);
}
`, ""]);
// Exports
export var listItem = `_VEQSmMHqM84jA`;
export var isDragging = `DuzkrSUJiOPXP4`;
export var isMoving = `Sv2W0Enm0ueRbF`;
export var listItemGrid = `VCrcTH6nCHY0y7`;
export var switcherTileStyleOverwrite = `l_NGnetFCZe3nk`;
export var dropIndicator = `TWQslu3N2ieXcM`;
export default ___CSS_LOADER_EXPORT___;
